var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative z-30 flex justify-center w-full px-1 py-2 text-white lg:px-6 lg:py-3 bg-brandRed",class:['bg-color--' + _vm.backgroundColor],style:([
    _vm.textColor !== '' ? { color: _vm.textColor } : '',
    _vm.backgroundColor !== '' ? { backgroundColor: _vm.backgroundColor } : '',
  ])},[_c('span',{staticClass:"text-[10px] flex justify-center tracking-widest lg:hidden"},[_vm._v(_vm._s(_vm.topbarTexts[0].mobileText))]),_vm._v(" "),_c('span',{staticClass:"hidden text-sm tracking-widest lg:block"},[_vm._v(_vm._s(_vm.topbarTexts[0].desktopText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }